require('./cardPayLaterView.scss');
// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @actions
const cardPayLaterActions = require('actions/cardPayLater');
const { getCreditCardPayLaterOptedInfo, creditCardPayLaterInfoReset } = require('actions/creditCardPayLaterInfo');

// @commons
const { formatText, getFinalTitle, FormattedText } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const WizardError = require('components/commons/wizardError/wizardError');

// @components
const CardPayLater = require('components/cards/cardPayLater/cardPayLater');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const CardPayLaterSuccessStep = require('components/cards/cardPayLaterSteps/cardPayLaterSuccessStep/cardPayLaterSuccessStep');
const CardPayLaterErrorStep = require('components/cards/cardPayLaterSteps/cardPayLaterErrorStep/cardPayLaterErrorStep');
const { LoadingSection } = require('commonsComponents/loadingSection');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');

// @constants
const { CARD_INTERVENTION_OWNER, GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');
const { CARD_CREDIT } = require('constants/index');

// @helper
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');
const { conditionalClassName, contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

class CardPayLaterView extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancelPayLater = this.handleCancelPayLater.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.goToMovementsPage = this.goToMovementsPage.bind(this);
    }

    componentDidMount() {
        const { history, immCards, match: { params: { cardId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const type = immCard.get('type');
        if (type === CARD_CREDIT) {
            this.props.getCreditCardPayLaterOptedInfo(immCard);
        }
        AccessHelper.allowAccess(cardConstants.CARD_PAY_LATER, { immCard }, history);
        this.props.requestPayLaterInfo(cardId);

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/paga-despues', PAGE_GENERIC, '', '', tagging);
    }

    componentWillUnmount() {
        this.props.clearRequest();
        this.props.creditCardPayLaterInfoReset();
    }

    goToMovementsPage() {
        const { match: { params: { cardId } }, history } = this.props;

        history.push(`/myprofile/cards/${cardId}/movements`);
    }

    handleFinish() {
        const { match: { params: { cardId } } } = this.props;
        this.props.postPayLater(cardId);
    }

    handleCancelPayLater() {
        const { match: { params: { cardId } }, history } = this.props;
        history.push(`/myprofile/cards/${cardId}/cancel-pay-later`);
    }

    render() {
        const {
            immCCPayLaterOptedInfo,
            immCards,
            immCardPayLater,
            immFlagBasedFeatures,
            immGlobalVariables,
            match: { params: { cardId } },
            setImportMaxMin,
            setVisibleStep,
            setWillCancel,
            validateStep,
        } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        let content = (<div></div>);

        if (immCards.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immCard) {
            if (immCard.get('interventionType') !== CARD_INTERVENTION_OWNER) {
                this.goToMovementsPage();
            }
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const hasError = !!immCardPayLater.get('error') || !!immCardPayLater.get('informationError');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('cardPayLater-title')
                }
            ];
            const tutorial = (
                <TutorialLauncher
                    type={GRAPHIC_TUTOR_TYPE_4}
                    title={formatText('tutorials-cardsPayLaterTitle')}
                />
            );
            let bodyContent;

            if (immCCPayLaterOptedInfo.get('isFetching')) {
                bodyContent = <LoadingSection />;
            } else if (immCCPayLaterOptedInfo.get('payLaterOpted')) {
                const goBackButtonLabel = formatText('cardPayLater-payLaterOptedErrorButtonText').toUpperCase();
                const goBackButton = {
                    label: goBackButtonLabel,
                    url: `/myprofile/cards/${cardId}/movements`
                };
                let cancelPayLaterButton;

                if (immFlagBasedFeatures.get('card-cancel-pay-later-enabled')) {
                    cancelPayLaterButton = (
                        <div className="card-pay-later__cancel-pay-later-button">
                            <OKButton modifier="secondary" onClick={this.handleCancelPayLater}>
                                <FormattedText value="cardPayLater-cancelPayLaterButton" />
                            </OKButton>
                        </div>
                    );
                }
                bodyContent = (
                    <article className="card-pay-later-error row no-gutter">
                        <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                            <WizardError
                                errorMessage={formatText('cardPayLater-payLaterOptedErrorTitle')}
                                mainButton={goBackButton}
                            >
                                <div>
                                    <p>
                                        <FormattedText
                                            value="cardPayLater-payLaterOptedErrorSubMsg1"
                                            injectedStrings={[immCCPayLaterOptedInfo.get('payLaterOptedDate')]}
                                        />
                                    </p>
                                    <p>
                                        <FormattedText
                                            value="cardPayLater-payLaterOptedErrorSubMsg2"
                                        />
                                    </p>
                                    {cancelPayLaterButton}
                                </div>
                            </WizardError>
                        </div>
                    </article>
                );
            } else if (immCardPayLater.get('submitSuccessful')) {
                bodyContent = (
                    <CardPayLaterSuccessStep
                        immCard={immCard}
                        immCardPayLater={immCardPayLater}
                    />
                );
            } else if (hasError) {
                bodyContent = (
                    <CardPayLaterErrorStep
                        immCard={immCard}
                        error={immCardPayLater.get('error')}
                    />
                );
            } else {
                const firstSidebarClassName = conditionalClassName('col-md-12 hidden-lg grid-view--fix-cell-separation-bottom', 'hidden')
                const mainContentClassName = conditionalClassName('col-md-12 col-lg-8', 'card-pay-later__content col-xs-8')
                const secondSidebarClassName = conditionalClassName('hidden-xs hidden-sm hidden-md col-lg-4', 'card-pay-later__sidebar col-xs-4')

                bodyContent = (
                    <div>
                        {/* >> CONTENT DUPLICATED: REF-01 */}
                        <div className={firstSidebarClassName}>
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                        {/* CONTENT DUPLICATED: REF-01 << */}
                        <div className={mainContentClassName}>
                            <CardPayLater
                                immCard={immCard}
                                immCardPayLater={immCardPayLater}
                                immGlobalVariables={immGlobalVariables}
                                validateStep={validateStep}
                                setVisibleStep={setVisibleStep}
                                setWillCancel={setWillCancel}
                                onFinish={this.handleFinish}
                                setImportMaxMin={setImportMaxMin}
                            />
                        </div>
                        {/* >> REF-01 */}
                        <div className={secondSidebarClassName}>
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                        {/* REF-01 << */}
                    </div>
                );
            }

            const cardPayLaterClassName = contactCenterClassName('card-pay-later')

            content = (
                <div className={cardPayLaterClassName}>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    tutorial={tutorial}
                                    finalTitle={getFinalTitle('cardPayLater-title')}
                                >
                                    <CardHeaderDetails immCard={immCard} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {bodyContent}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return content;
    }
}

CardPayLaterView.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardPayLater: PropTypes.object.isRequired,
    immCCPayLaterOptedInfo: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setImportMaxMin: PropTypes.func.isRequired,
    postPayLater: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    requestPayLaterInfo: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    getCreditCardPayLaterOptedInfo: PropTypes.func.isRequired,
    creditCardPayLaterInfoReset: PropTypes.func.isRequired
};

module.exports.constructor = CardPayLaterView;
module.exports.CardPayLaterView = connect(
    state => ({
        immCards: state.cards,
        immCardPayLater: state.cardPayLater,
        immCCPayLaterOptedInfo: state.creditCardPayLaterInfo,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables
    }), {
    validateStep: cardPayLaterActions.validateStep,
    setVisibleStep: cardPayLaterActions.setVisibleStep,
    setWillCancel: cardPayLaterActions.setWillCancel,
    postPayLater: cardPayLaterActions.postPayLater,
    clearRequest: cardPayLaterActions.clearRequest,
    requestPayLaterInfo: cardPayLaterActions.requestPayLaterInfo,
    setImportMaxMin: cardPayLaterActions.setImportMaxMin,
    getCreditCardPayLaterOptedInfo: getCreditCardPayLaterOptedInfo,
    creditCardPayLaterInfoReset: creditCardPayLaterInfoReset
})(withRouter(CardPayLaterView));
